import { parrotApi } from '@libs/openapi';
import { useEffect, useState } from 'react';
import { OpenapiClientParrotVault } from 'src/openapi/parrot-vault';
import { useRefreshTime } from './use-refresh';

export const useVaultSummary = () => {
  const { refreshTime } = useRefreshTime();
  const [summary, setSummary] = useState<OpenapiClientParrotVault.GetVaultStatsSummaryResponse>();

  const getVaultSummary = async () => {
    const result = await parrotApi.get('/vault/stats/summary', {});
    setSummary(result);
  };

  useEffect(() => {
    let timer: NodeJS.Timeout | undefined;
    const loop = () => {
      getVaultSummary();
      timer = setTimeout(() => {
        loop();
      }, 60 * 1000);
    };
    loop();
    return () => {
      clearTimeout(timer);
    };
  }, [refreshTime]);

  return {
    summary,
  };
};
